'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_EditPolicyPage(code) {
  this.Ct = null;
  this.Ct = code;
}
export { $c_Lpresto_EditPolicyPage as $c_Lpresto_EditPolicyPage };
$p = $c_Lpresto_EditPolicyPage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_EditPolicyPage;
/** @constructor */
function $h_Lpresto_EditPolicyPage() {
}
export { $h_Lpresto_EditPolicyPage as $h_Lpresto_EditPolicyPage };
$h_Lpresto_EditPolicyPage.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_EditPolicyPage) && (this.Ct === x$0.Ct)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "EditPolicyPage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Ct;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_EditPolicyPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ia)));
}
export { $isArrayOf_Lpresto_EditPolicyPage as $isArrayOf_Lpresto_EditPolicyPage };
var $d_Lpresto_EditPolicyPage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_EditPolicyPage, "presto.EditPolicyPage", ({
  ia: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_EditPolicyPage as $d_Lpresto_EditPolicyPage };
//# sourceMappingURL=presto.-Edit-Policy-Page.js.map
